import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CompensationType, Namespace } from 'enums';

export const useCompensationTypes = (isUserMode = false) => {
  const { t } = useTranslation(Namespace.CompensationTypes);

  return useMemo(
    () => [
      {
        label: t(CompensationType.Sport),
        value: CompensationType.Sport,
      },
      {
        label: t(CompensationType.Robotics),
        value: CompensationType.Robotics,
      },

      {
        label: t(CompensationType.Wedding),
        value: CompensationType.Wedding,
      },
      {
        label: t(CompensationType.Children),
        value: CompensationType.Children,
      },
      {
        label: t(CompensationType.FamilyFuneral),
        value: CompensationType.FamilyFuneral,
      },
      {
        label: t(CompensationType.InternetCompensation),
        value: CompensationType.InternetCompensation,
      },
      {
        label: t(CompensationType.Medical),
        value: CompensationType.Medical,
      },
      ...(!isUserMode
        ? [
            {
              label: t(CompensationType.Recommendation),
              value: CompensationType.Recommendation,
            },
            {
              label: t(CompensationType.Other),
              value: CompensationType.Other,
            },
          ]
        : []),
    ],
    [t, isUserMode],
  );
};
